import { DateInput } from "@/components/DateInput";
import { Label } from "@/components/ui/label";
import { useLang } from "@/i18n";

export const PeriodFilter = ({ from, to, setFrom, setTo, prefix = "period" }) => {
  const { t } = useLang();
  return (
    <div className="flex flex-wrap items-end gap-3">
      <div className="space-y-1">
        <Label className="text-xs uppercase tracking-wider text-slate-500">{t("start_date")}</Label>
        <DateInput value={from} onChange={(e) => setFrom(e.target.value)} className="font-mono w-40" data-testid={`${prefix}-from-input`} />
      </div>
      <div className="space-y-1">
        <Label className="text-xs uppercase tracking-wider text-slate-500">{t("end_date")}</Label>
        <DateInput value={to} onChange={(e) => setTo(e.target.value)} className="font-mono w-40" data-testid={`${prefix}-to-input`} />
      </div>
    </div>
  );
};

export const yearStart = () => `${new Date().getFullYear()}-01-01`;
export const today = () => new Date().toISOString().slice(0, 10);
export const money = (v) => (v === 0 ? "—" : new Intl.NumberFormat("el-GR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v));
